/**
 * @Description: VIP_V4_OPENED
 * @author XuZiYu
 * @date 2021/12/08 10:20:29
*/

<template>
  <div class="wrapper-opened">

    <!--头部-->
    <template v-if="!H5 && headVisible !== '0'">
      <div class="header">
        <div class="header-left" @click="goBack"><img src="@/assets/vip/icon_back.png" alt=""/></div>
        <div class="header-main" >VIP课程</div>
        <div class="header-share" v-if="shareVisible" @click="openSharePanel"><img src="@/assets/public/icon_fx02.png" alt=""></div>
        <div class="header-right" v-if="!H5" @click="pushCusService"><img src="@/assets/vip/icon_customerservice.png" alt=""></div>
      </div>
    </template>

    <!--分享框架-->
    <share-ad :detail="shareData">
      <div class="user-info">
        <div class="user-info-left">
          <div class="user-img">
            <img v-if="userInfo.logoUrl" :src="userInfo.logoUrl" alt=""/>
            <img v-else src="@/assets/vip/default-user-img.png" alt=""/>
          </div>
        </div>
        <div class="user-info-right">
          <div class="user-name">
            <span v-if="userInfo.petName">{{userInfo.petName}}</span>
            <img v-if="subject === 1" src="@/assets/vip/icon_vipk1.png" alt=""/>
            <img v-if="subject === 3" src="@/assets/vip/icon_vipk3.png" alt=""/>
            <img v-if="subject === 4" src="@/assets/vip/icon_vipk4.png" alt=""/>
          </div>
          <div v-if="subject === 3" class="user-use-time">有效期至{{vipData.vipEr3UserValidTime}}</div>
          <div v-else class="user-use-time">有效期至{{openedData.effectiveDate}}</div>
        </div>
      </div>
      <div class="menu">
        <div class="menu-title">VIP课程服务</div>
        <div class="nav">
          {{subjectName[subject]}}
          <span class="nav-button" @click="changeSubject">切换</span>
        </div>
      </div>
      <div v-if="subject === 3" class="app-modular video">
        <div class="item" @click="goFnModular('pushExamPlaceRoutePage')">
          <img class="item-icon" src="@/assets/vip/icon_zskcsp.png" alt="">
          真实考场实拍
        </div>
        <div class="item" @click="goFnModular('pushExamPlaceRoutePage')">
          <img class="item-icon" src="@/assets/vip/icon_lxjj.png" alt="">
          路线讲解
        </div>
        <div class="item" @click="goFnModular('pushExamPlaceRoutePage')">
          <img class="item-icon" src="@/assets/vip/icon_czyl.png" alt="">
          操作演练
        </div>
        <div class="item" @click="goFnModular('pushExamPlaceRoutePage')">
          <img class="item-icon" src="@/assets/vip/icon_zysx.png" alt="">
          注意事项
        </div>
      </div>
      <div v-else class="app-modular">
        <div class="item" @click="goFnModular('pushFeaturedPage')">
          <img class="item-icon" src="@/assets/vip/icon_jx500t.png" alt="">
          精选500题
        </div>
        <div class="item" @click="goFnModular('pushErrorProneStrengthenPage')">
          <img class="item-icon" src="@/assets/vip/icon_yctgg.png" alt="">
          易错题巩固
        </div>
        <div class="item" @click="goFnModular('pushKnowledgeShorthandPage')">
          <img class="item-icon" src="@/assets/vip/icon_zsdsj.png" alt="">
          知识点速记
        </div>
        <div class="item" @click="goFnModular('pushExamBreakthroughPage')">
          <img class="item-icon" src="@/assets/vip/icon_kqtj.png" alt="">
          考前突击
        </div>
        <div class="item" @click="goFnModular('pushExamSecretPage')">
          <img class="item-icon" src="@/assets/vip/icon_kqmj.png" alt="">
          考前秘卷
        </div>
        <div class="item" @click="goFnModular('pushExamIntelligentPage')">
          <img class="item-icon" src="@/assets/vip/icon_znks.png" alt="">
          智能考试
        </div>
        <div class="item" @click="goFnModular('pushExamPassRatePage')">
          <img class="item-icon" src="@/assets/vip/icon_yctgl.png" alt="">
          预测通过率
        </div>
        <div class="item" @click="goFnModular('pushExamRealisticPage')">
          <img class="item-icon" src="@/assets/vip/icon_kcmn.png" alt="">
          考场模拟
        </div>
        <div class="item new" @click="goFnModular('pushListenQuestionPage')">
          <img class="item-icon" src="@/assets/vip/icon_lrtt_ykt.png" alt="">
          懒人听题
        </div>
      </div>
      <div class="ensure-modular" v-if="openedData.ensureFlag && subject !== 3">
        <div class="ensure-modular-header">
          <div class="left">
            <h3 class="h3">过考保障</h3>
            <img class="icon" v-if="!openedData.perfectInfoFlag" src="@/assets/vip/icon_gth.png" alt="">
            <h4 class="h4" v-if="!openedData.perfectInfoFlag">您尚未完善个人信息</h4>
          </div>
          <div class="right" v-if="!openedData.perfectInfoFlag" @click="goPerfectInfo">去填写</div>
        </div>
        <div class="ensure-modular-content">
          <div class="left" @click="goCard">
            <h3 class="h3">科一保障卡</h3>
            <h3 class="h4">考试不过可补偿50元</h3>
            <template v-if="Number(openedData.ensureActiveFlag1) === 0">
              <div class="button active" @click="goCard">去激活</div>
              <img class="tag" src="@/assets/vip/icon_wjh.png" alt="">
            </template>
            <template v-if="Number(openedData.ensureActiveFlag1) === 1">
              <div class="button apply">申请补偿</div>
              <img class="tag" src="@/assets/vip/icon_yjh.png" alt="">
            </template>
            <template v-if="Number(openedData.ensureActiveFlag1) === 2">
              <div class="button apply">补偿记录</div>
              <img class="tag" src="@/assets/vip/icon_ysy.png" alt="">
            </template>

          </div>
          <div class="right" @click="goCard">
            <h3 class="h3">科四保障卡</h3>
            <h3 class="h4">考试不过可补偿50元</h3>
            <template v-if="Number(openedData.ensureActiveFlag4) === 0">
              <div class="button active">去激活</div>
              <img class="tag" src="@/assets/vip/icon_wjh.png" alt="">
            </template>
            <template v-if="Number(openedData.ensureActiveFlag4) === 1">
              <div class="button apply">申请补偿</div>
              <img class="tag" src="@/assets/vip/icon_yjh.png" alt="">
            </template>
            <template v-if="Number(openedData.ensureActiveFlag4) === 2">
              <div class="button apply">补偿记录</div>
              <img class="tag" src="@/assets/vip/icon_ysy.png" alt="">
            </template>
          </div>
        </div>
      </div>
      <div class="rule">
        <div class="rule-title">服务说明</div>
        <p class="p" v-if="openedData.ensureFlag && subject !== 3">1、感谢您购买了VIP课程，购买后即刻生效。
          2、VIP课程为虚拟商品，购买后不支持退款。
          3、保障卡为VIP权益，激活后有效期至VIP课程失效日，VIP课程失效后无法申请补偿。如：2021年8月11日开通VIP课程（含过考保障），则VIP课程和保障卡有效期至2022年8月10日。
          4、为确保您过考保障的权益，开通VIP课程后，请在考试前一天激活保障卡，考试之前未激活则不能申请补偿。
          5、请您及时填写个人信息，并确保姓名和身份证号码填写正确（只能填写一次，不得修改），如您的信息与考生信息不符，无法正常申请补偿。
          6、补偿科目一和科目四，且一个身份证号分别只能得到补偿一次。
          7、审核时间：补偿申请提交后5-7个工作日内完成审核，打款将会发放至填写的账户信息，请确保账户为本人所有。
          8、如有疑问，可联系斑斑在线客服，在线客服工作时间为周一至周五9:00-12点，14:00-18:30。</p>
        <p class="p" v-else>1、感谢您购买了VIP课程，购买后即刻生效。
          2、VIP课程为虚拟产品，不支持退款。
          3、如有疑问，请联系斑斑客服。</p>
      </div>
    </share-ad>
  </div>
</template>

<script>
import { Toast } from 'vant'

export default {
    name: 'vipV4Opened',
    props: ['vipData', 'userInfo', 'cityCode'],
    methods: {
        // 返回
        goBack () {
            this.$jsBridge.callBackHandler('returnLastPage')
        },
        // 切换课程
        changeSubject () {
            // H5标记不能切换
            if (this.H5) {
                this.linkApp()
                return
            }

            if (this.subject === 1 && this.vipData.vipEr3OpenFlag) {
                this.subject = 3
            } else if (this.subject === 1 && !this.vipData.vipEr3OpenFlag) {
                this.subject = 4
            } else if (this.subject === 3) {
                this.subject = 4
            } else if (this.subject === 4) {
                this.subject = 1
            }
        },
        // 跳转app
        linkApp () {
            // 判断设备
            if (this.IOS) {
                // qq浏览器特殊处理
                if (String(navigator.userAgent.toLowerCase().match(/QQ/i)) === 'qq') {
                    let body = document.querySelectorAll('body')[0]
                    let div = document.createElement('div')
                    let img = document.createElement('img')
                    div.style = 'width: 100%;position: fixed;height: 100%;top: 0;background: rgb(0 0 0 / 80%);z-index: 9;'
                    div.onclick = () => {
                        body.removeChild(div)
                    }
                    img.src = require('@/assets/public/icon_fxts.png')
                    img.style = 'width:100%'
                    div.appendChild(img)
                    body.appendChild(div)
                    return true
                }

                // 根据分享app类型跳转
                location.href = Number(this.appType) === 2
                    ? 'https://share.banbanjiadao.com/ui/h5/bbjd/index'
                    : 'https://share.banbanjiadao.com/ui/h5/bb/index'
            } else {
                // 根据分享app类型跳转
                location.href = Number(this.appType) === 2
                    ? 'https://a.app.qq.com/o/simple.jsp?pkgname=com.banbanjiadao.activity&android_schema=banbanjiadao%3a%2f%2fopen'
                    : 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ctl.student&android_schema=chetailian%3a%2f%2fopen&ios_scheme=chetailian%3a%2f%2fopen'
            }
        },
        // 联系客服
        pushCusService () {
            this.$jsBridge.callBackHandler('pushCusService')
        },
        // 进入功能模块
        goFnModular (v) {
            // H5标记不能进入
            if (this.H5) {
                this.linkApp()
                return
            }
            // 未登录不能使用
            if (!this.userInfo.userId) {
                this.$jsBridge.callBackHandler('loginUserV2')
                return
            }

            if (v === 'pushListenQuestionPage' && !this.$jsBridge.hasNativeMethod('pushListenQuestionPage')) {
                Toast('请升级至最新版本体验此功能！')
                return
            }

            // 跳转功能
            this.$jsBridge.callBackHandler(v, { subject: this.subject })
        },
        // 打开分享面板
        openSharePanel () {
            // 标题
            let title = this.shareData.shareTitle || 'VIP课程'
            // 内容
            let content = '掌握一题=练习多题，轻松搞定科一&科四！'
            // 分享链接
            let shareUrl = ''
            // 图片链接
            let imageUrl = this.shareData.shareGroupImg
            // 页面编码
            let pageCode = 'question-bank'

            if (this.shareData.shareType === '1') {
                // 处理域名替换
                shareUrl = location.origin.replace('app.banbanjiadao.com', 'app.banbanjd.cn').replace('app.chetailian.com', 'app.banbanjd.cn')

                // 拼接路径
                shareUrl += location.pathname

                // 拼接参数
                shareUrl += `?shareType=h5&appType=${this.appType}&cityCode=${this.cityCode}`

                // 设置图片链接
                imageUrl = this.shareData.shareImg || 'http://app.static.public.chetailian.com/share/VIPtk.png'
            }

            // 唤起分享
            this.$jsBridge.callBackHandler('share', { title, content, shareUrl, imageUrl, pageCode })
        },
        // 获取分享配置信息
        getSetting () {
            this.$api.getAdSetting({ code: 'question-bank' }).then(res => {
                if (res.status && res.result) {
                    this.shareData = res.result
                }
            })
        },
        // 跳转完善个人信息
        goPerfectInfo () {
            if (!this.userInfo.userId) {
                this.$jsBridge.callBackHandler('loginUser')
                return
            }
            this.$router.push({ name: 'ensurePerfectInfo', query: { vipUserId: this.openedData.vipUserId } })
        },
        // 跳转理论保障卡
        goCard () {
            if (!this.userInfo.userId) {
                this.$jsBridge.callBackHandler('loginUser')
                return
            }
            this.$router.push({ name: 'ensureCard', query: { vipUserId: this.openedData.vipUserId } })
        },
        // 初始化
        init () {
            // 设置vip已开通数据
            this.openedData = JSON.parse(JSON.stringify(this.vipData.examIsVipPageDataDTO)) || {}

            // 设置vip开通数据
            this.openData = JSON.parse(JSON.stringify(this.vipData.examVipSettingDTO))

            // 设置app类型
            this.appType = this.$jsBridge.callBackHandler('getAppType') || (typeof this.$route.query.appType === 'object' ? this.$route.query.appType[0] : this.$route.query.appType)

            // 设置H5标记
            this.H5 = this.$route.query.shareType === 'h5'

            // 设置分享显示
            this.shareVisible = !this.H5

            // 设置头部显示
            this.headVisible = this.$route.query.headShow || '1'

            // 设置科目
            this.subject = Number(this.$route.query.subject) || 1
        }
    },
    mounted () {
        this.init()
    },
    created () {
        this.getSetting()
    },
    data () {
        return {
            // vip已开通数据
            openedData: {},
            // vip开通数据
            openData: {},
            // 科目名称
            subjectName: {
                1: '科目一',
                3: '科目三',
                4: '科目四'
            },
            // app类型 1-定制版 2-学时版
            appType: '',
            // 科目
            subject: 1,
            // h5标记
            H5: false,
            // 分享数据
            shareData: {},
            // 显示分享
            shareVisible: false,
            // 头部显示
            headVisible: ''
        }
    }
}
</script>

<style lang="scss">
  * {
    touch-action: pan-y;
  }

  .wrapper-opened {
    position: relative;
    overflow: auto;
    background-color: #FAFAFA;
    background-size: 100%;

    .header {
      padding-top: 10px;
      position: relative;
      z-index: 2;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 44px;
      background: url('~@/assets/vip/background_vipkc_top.png') no-repeat;
      background-size: 375px 54px;

      .header-main {
        font-size: 18px;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
      }

      .header-share {
        position: absolute;
        height: 60px;
        display: flex;
        align-items: center;
        right: 50px;
        font-size: 0;
        line-height: 1;

        img {
          width: 24px;
        }
      }

      .header-left, .header-right {
        display: flex;
        align-items: center;
        font-size: 0;
        padding: 0 10px;
        line-height: 1;
        height: 100%;

        img {
          width: 24px;
          height: 24px;
        }
      }
    }

    .header-bg {
      position: absolute;
      width: 375px;
      top: 0;
      z-index: 1;

      .header-bg-img {
        width: 100%;
      }
    }

    .user-info {
      position: relative;
      z-index: 2;
      width: 375px;
      height: 140px;
      background-size: 100%;
      margin: 0 auto 0;
      display: flex;
      align-items: center;
      background: url('~@/assets/vip/background_vipkc.png') no-repeat top;
      background-size: 375px 140px;

      .user-info-left {
        padding: 0 15px 0 30px;

        .user-img {
          width: 60px;
          height: 60px;
          border-radius: 100%;
          overflow: hidden;

          img {
            width: 60px;
          }
        }
      }

      .user-info-right {
        display: flex;
        flex-direction: column;
        justify-content: center;

        .user-name {
          font-size: 18px;
          margin-top: 5px;
          font-weight: 600;
          color: #F5D7AA;
          display: flex;
          align-items: center;

          span {
            margin-right: 7px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          img {
            width: 54px;
          }
        }

        .user-use-time {
          margin-top: 5px;
          font-size: 14px;

          font-weight: 400;
          color: #F5D7AA;
        }
      }
    }

    .menu {
      display: flex;
      justify-content: space-between;
      padding: 0 15px;
      margin-top: 35px;

      .menu-title {
        font-size: 18px;
        font-weight: 600;
        color: #333333;
      }

      .nav {
        display: flex;
        align-items: center;
        font-size: 15px;
        font-weight: 400;
        color: #333333;

        .nav-button {
          margin-left: 7.5px;
          padding: 0 5px;
          border-radius: 9px;
          background-color: #C8A06A;
          font-size: 13px;
          font-weight: 400;
          color: #FFFFFF;;
        }
      }
    }

    .app-modular {
      margin: 10px auto 0;
      padding-bottom: 30px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      align-content: flex-start;
      justify-content: space-between;
      width: 345px;
      background: #FFFFFF;
      border-radius: 5px;

      .item {
        margin-top: 30px;
        justify-content: center;
        align-items: center;
        width: 80px;
        display: flex;
        flex-direction: column;
        font-size: 13px;
        font-weight: 400;
        color: #333333;
      }

      .item-icon {
        margin-bottom: 10px;
        width: 50px;
      }
    }

    .app-modular.video{
      box-sizing: border-box;
      padding: 0 8px 30px;
    }

    .ensure-modular {
      width: 345px;
      margin: 15px auto 0;

      .ensure-modular-header {
        display: flex;
        align-items: center;

        .left {
          display: flex;
          align-items: center;
          flex: 1;
        }

        .right {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 60px;
          height: 18px;
          border-radius: 9px;
          border: 1px solid #C8A06A;
          font-size: 13px;
          font-weight: 400;
          color: #C8A06A;
        }

        .h3 {
          font-size: 18px;
          font-weight: 600;
          color: #333333;
        }

        .icon {
          margin: 0 5px 0 10px;
          width: 12px;
        }

        .h4 {
          font-size: 13px;
          font-weight: 400;
          color: #666666;
        }
      }

      .ensure-modular-content {
        margin-top: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .left, .right {
          box-sizing: border-box;
          padding: 0 15px;
          position: relative;
          width: 165px;
          height: 100px;
          background: linear-gradient(135deg, #EAD9C1 0%, #E2C59D 100%);
          box-shadow: 0 5px 5px 0 rgba(228, 201, 165, 0.2);
          border-radius: 5px;
        }

        .tag {
          width: 50px;
          height: 20px;
          position: absolute;
          right: 0;
          top: 0;
        }

        .h3 {
          margin-top: 12px;
          line-height: 1;
          font-size: 18px;
          font-weight: 600;
          color: #926E3D;
        }

        .h4 {
          margin-top: 10px;
          line-height: 1;
          font-size: 13px;
          font-weight: 400;
          color: #926E3D;
        }

        .button {
          margin-top: 10px;
        }

        .button.apply {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 80px;
          height: 24px;
          background: #FFFFFF;
          border-radius: 12px;
          font-size: 13px;
          font-weight: 400;
          color: #926E3D;
        }

        .button.active {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 60px;
          height: 24px;
          border-radius: 12px;
          border: 1px solid #926E3D;
          font-size: 13px;
          font-weight: 400;
          color: #926E3D;
        }
      }
    }

    .rule {
      margin: 15px auto;
      width: 345px;
      min-height: 250px;
      background: #FFFFFF;
      border-radius: 5px;

      .rule-title {
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 120px;
        height: 30px;
        background: linear-gradient(180deg, #C8A06A 0%, #C8A06A 100%);
        border-radius: 0 0 10px 10px;
        font-size: 18px;
        font-weight: 600;
        color: #FFFFFF;
      }

      .p {
        white-space: pre-line;
        line-height: 24px;
        font-size: 13px;
        font-weight: 400;
        color: #333333;
        padding: 12px 15px 20px;
      }

      b{
        color: #FF5C5C;
      }
    }

      @keyframes rotate {
          0% { transform: rotate(-10deg) }
          25% { transform: rotate(0) }
          50% { transform: rotate(10deg) }
          75% { transform: rotate(0deg) }
          100% { transform: rotate(-10deg) }
      }

      .new{
          position: relative;
      }
      .new::after{
          animation: rotate .8s infinite;
          position: absolute;
          right: -5px;
          top: -10px;
          width: 27px;
          height: 21px;
          content: '';
          display: block;
          background: url("~@/assets/vipV3/icon_new.png") no-repeat 0% / 100%;
      }
  }
</style>
